import { DietDTO } from 'types';
import { jsonObjectsTexts } from 'consts/text';
import { getFormattedPrice } from 'utils/getFormattedPrice';
import { EMPTY_VALUE_LABEL } from 'consts/labels/common';

export const parseDietDTOIntoJsonObject: (dietDTO: DietDTO) => object = (dietDTO) => {
    const { name, meals } = dietDTO;

    // Get current meal prices from the most recent entry
    const currentMealPrices = meals?.[0]?.mealPrices || [];

    const result: Record<string, string> = {
        [jsonObjectsTexts.dietDTO.fields.name]: name,
    };

    // Exclude 'name' from fields, only process meal price fields
    Object.entries(jsonObjectsTexts.dietDTO.fields).forEach(([key, label]) => {
        if (key === 'name') return;
        // The convention is mealTypeId === key.replace('Price', '')
        // e.g. 'breakfastPrice' -> 'breakfast'
        const mealTypeId = key.replace('Price', '');
        const mealPriceObj = currentMealPrices?.find((mp) => mp.mealTypeId === mealTypeId);
        result[label] =
            mealPriceObj && mealPriceObj.price != null
                ? getFormattedPrice(mealPriceObj.price)
                : EMPTY_VALUE_LABEL;
    });

    return result;
};
